/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { DataSourceLoadOptionsBase } from '../models/data-source-load-options-base';
import { LoadResult } from '../models/load-result';
import { TypeElementStockDto } from '../models/type-element-stock-dto';


/**
 * Fonctions de gestion des types d'éléments en stock
 */
@Injectable({
  providedIn: 'root',
})
export class TypesElementsStockService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation typeElementStockGetList
   */
  static readonly TypeElementStockGetListPath = '/api/types-elements-stock/list';

  /**
   * Renvoie la liste des types d'éléments en stock.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `typeElementStockGetList()` instead.
   *
   * This method doesn't expect any request body.
   */
  typeElementStockGetList$Response(params?: {
  }): Observable<StrictHttpResponse<Array<TypeElementStockDto>>> {

    const rb = new RequestBuilder(this.rootUrl, TypesElementsStockService.TypeElementStockGetListPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<TypeElementStockDto>>;
      })
    );
  }

  /**
   * Renvoie la liste des types d'éléments en stock.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `typeElementStockGetList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  typeElementStockGetList(params?: {
  }): Observable<Array<TypeElementStockDto>> {

    return this.typeElementStockGetList$Response(params).pipe(
      map((r: StrictHttpResponse<Array<TypeElementStockDto>>) => r.body as Array<TypeElementStockDto>)
    );
  }

  /**
   * Path part for operation typeElementStockLoadList
   */
  static readonly TypeElementStockLoadListPath = '/api/types-elements-stock/load-list';

  /**
   * Renvoie la liste des types d'éléments en stock (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `typeElementStockLoadList()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  typeElementStockLoadList$Response(params: {

    /**
     * Identifiant du parc
     */
    parcId?: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<StrictHttpResponse<LoadResult>> {

    const rb = new RequestBuilder(this.rootUrl, TypesElementsStockService.TypeElementStockLoadListPath, 'post');
    if (params) {
      rb.query('parcId', params.parcId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoadResult>;
      })
    );
  }

  /**
   * Renvoie la liste des types d'éléments en stock (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `typeElementStockLoadList$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  typeElementStockLoadList(params: {

    /**
     * Identifiant du parc
     */
    parcId?: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<LoadResult> {

    return this.typeElementStockLoadList$Response(params).pipe(
      map((r: StrictHttpResponse<LoadResult>) => r.body as LoadResult)
    );
  }

  /**
   * Path part for operation typeElementStockGet
   */
  static readonly TypeElementStockGetPath = '/api/types-elements-stock/{id}';

  /**
   * Renvoie le type d'élément en stock spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `typeElementStockGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  typeElementStockGet$Response(params: {

    /**
     * Identifiant du type d&#x27;élément en stock
     */
    id: number;
  }): Observable<StrictHttpResponse<TypeElementStockDto>> {

    const rb = new RequestBuilder(this.rootUrl, TypesElementsStockService.TypeElementStockGetPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TypeElementStockDto>;
      })
    );
  }

  /**
   * Renvoie le type d'élément en stock spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `typeElementStockGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  typeElementStockGet(params: {

    /**
     * Identifiant du type d&#x27;élément en stock
     */
    id: number;
  }): Observable<TypeElementStockDto> {

    return this.typeElementStockGet$Response(params).pipe(
      map((r: StrictHttpResponse<TypeElementStockDto>) => r.body as TypeElementStockDto)
    );
  }

  /**
   * Path part for operation typeElementStockPut
   */
  static readonly TypeElementStockPutPath = '/api/types-elements-stock/{id}';

  /**
   * Met à jour le type d'élément en stock spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `typeElementStockPut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  typeElementStockPut$Response(params: {

    /**
     * Identifiant du type d&#x27;élément en stock à mettre à jour
     */
    id: number;

    /**
     * Type d'élément en stock
     */
    body: TypeElementStockDto
  }): Observable<StrictHttpResponse<TypeElementStockDto>> {

    const rb = new RequestBuilder(this.rootUrl, TypesElementsStockService.TypeElementStockPutPath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TypeElementStockDto>;
      })
    );
  }

  /**
   * Met à jour le type d'élément en stock spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `typeElementStockPut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  typeElementStockPut(params: {

    /**
     * Identifiant du type d&#x27;élément en stock à mettre à jour
     */
    id: number;

    /**
     * Type d'élément en stock
     */
    body: TypeElementStockDto
  }): Observable<TypeElementStockDto> {

    return this.typeElementStockPut$Response(params).pipe(
      map((r: StrictHttpResponse<TypeElementStockDto>) => r.body as TypeElementStockDto)
    );
  }

  /**
   * Path part for operation typeElementStockDelete
   */
  static readonly TypeElementStockDeletePath = '/api/types-elements-stock/{id}';

  /**
   * Supprime le type d'élément en stock spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `typeElementStockDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  typeElementStockDelete$Response(params: {

    /**
     * Identifiant du type d&#x27;élément en stock à supprimer
     */
    id: number;
  }): Observable<StrictHttpResponse<number>> {

    const rb = new RequestBuilder(this.rootUrl, TypesElementsStockService.TypeElementStockDeletePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: parseFloat(String((r as HttpResponse<any>).body)) }) as StrictHttpResponse<number>;
      })
    );
  }

  /**
   * Supprime le type d'élément en stock spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `typeElementStockDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  typeElementStockDelete(params: {

    /**
     * Identifiant du type d&#x27;élément en stock à supprimer
     */
    id: number;
  }): Observable<number> {

    return this.typeElementStockDelete$Response(params).pipe(
      map((r: StrictHttpResponse<number>) => r.body as number)
    );
  }

  /**
   * Path part for operation typeElementStockPost
   */
  static readonly TypeElementStockPostPath = '/api/types-elements-stock';

  /**
   * Crée le type d'élément en stock spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `typeElementStockPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  typeElementStockPost$Response(params: {

    /**
     * Type d'élément en stock
     */
    body: TypeElementStockDto
  }): Observable<StrictHttpResponse<TypeElementStockDto>> {

    const rb = new RequestBuilder(this.rootUrl, TypesElementsStockService.TypeElementStockPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TypeElementStockDto>;
      })
    );
  }

  /**
   * Crée le type d'élément en stock spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `typeElementStockPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  typeElementStockPost(params: {

    /**
     * Type d'élément en stock
     */
    body: TypeElementStockDto
  }): Observable<TypeElementStockDto> {

    return this.typeElementStockPost$Response(params).pipe(
      map((r: StrictHttpResponse<TypeElementStockDto>) => r.body as TypeElementStockDto)
    );
  }

  /**
   * Path part for operation typeElementStockGetListActifs
   */
  static readonly TypeElementStockGetListActifsPath = '/api/types-elements-stock/list-actifs';

  /**
   * Renvoie la liste des types d'éléments en stock actifs.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `typeElementStockGetListActifs()` instead.
   *
   * This method doesn't expect any request body.
   */
  typeElementStockGetListActifs$Response(params?: {
  }): Observable<StrictHttpResponse<Array<TypeElementStockDto>>> {

    const rb = new RequestBuilder(this.rootUrl, TypesElementsStockService.TypeElementStockGetListActifsPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<TypeElementStockDto>>;
      })
    );
  }

  /**
   * Renvoie la liste des types d'éléments en stock actifs.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `typeElementStockGetListActifs$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  typeElementStockGetListActifs(params?: {
  }): Observable<Array<TypeElementStockDto>> {

    return this.typeElementStockGetListActifs$Response(params).pipe(
      map((r: StrictHttpResponse<Array<TypeElementStockDto>>) => r.body as Array<TypeElementStockDto>)
    );
  }

}
